import { useState } from "react";
import { Button } from "@heroui/react";
import { Edit } from "lucide-react";
import { useTranslation } from "react-i18next";
import { type Shipment, ShipmentStatus } from "@/api.types.v2";
import { PrintShipmentLabelButton } from "./print-shipment-label-button";
import { canRequestCustomerShipmentChanges } from "@/api/shipment-action-eligibility";
import { ShipmentChangeRequestDialog } from "../shipment-change-request-dialog";

export function ShipmentCustomerActions({
  shipment,
  disabled = false,
}: {
  shipment: Shipment;
  disabled?: boolean;
}) {
  const { t } = useTranslation("app");
  const [changeOpen, setChangeOpen] = useState(false);
  const held = disabled || Boolean(shipment.cancellationRequestedAt);
  const showPrint = shipment.status === ShipmentStatus.LABEL_READY && !held;
  const showChanges =
    canRequestCustomerShipmentChanges(shipment.status) && !held;
  if (!showPrint && !showChanges) return null;
  return (
    <fieldset
      aria-label={`SHP-${shipment.shipmentNumber ?? "…"}`}
      className="flex min-w-0 flex-wrap items-center gap-2"
    >
      {showPrint && (
        <PrintShipmentLabelButton
          shipmentId={shipment.id}
          disabled={!shipment.packages?.some((piece) => piece.labelUrl)}
          label={t("orders.print")}
          disabledTitle={t("orders.labelNotReady")}
          variant="bordered"
        />
      )}
      {showChanges && (
        <Button
          size="sm"
          color="warning"
          variant="flat"
          startContent={<Edit className="h-4 w-4" />}
          onPress={() => setChangeOpen(true)}
        >
          {t("orders.requestChanges")}
        </Button>
      )}
      <ShipmentChangeRequestDialog
        open={changeOpen}
        onOpenChange={setChangeOpen}
        shipment={shipment}
      />
    </fieldset>
  );
}
